<script>
import TemplateMixin from './mixins/TemplateMixin';
import BaseGateway from './mixins/BaseGateway';
import PagseguroHandler from './libs/PagseguroHandler';

export default {
        name: "PagseguroGateway",
        mixins: [
            TemplateMixin,
            BaseGateway
        ],         
        computed:{
            gateway(){
                return 'pagseguro';
            },
            redirectUrl(){
                //We changed from pay to buy
                const baseUrl = this.clientURL +'/billing/' + this.gateway + '/buy/' + this.productData.id + '?type=' + this.productType
                let finalUrl = baseUrl;            

                //we set couponId only if users input coupon number is legit and a price is returned from the call
                if(this.activeCoupon != null){
                    finalUrl += "&coupon=" + this.activeCoupon.name;
                    //couponData holds coupon ajax info with the price
                    if(this.isFree){
                        finalUrl += "&couponFree=1"
                    }
                }                
                //Additional Data
                if(this.billingInfo){                    
                    finalUrl += "&additionalInfo=" + encodeURIComponent(this.billingInfo.replace(/\r\n|\r|\n/g,"<br />"));
                }
                return finalUrl;
            },        
        },
        mounted() {
            this.pagseguroHandler = new PagseguroHandler(this.clientURL, {
                setLoading: this.setLoading,
                setErrors: this.setErrors
            });
        },
        methods:{
            initCheckout(){
                console.log('checkout Pagseguro');
                console.log('product', this.product);
                console.log('Product Data', this.productData);
                console.log('Checkout Data', this.checkoutData);
                console.log('Redirect Url', this.redirectUrl);
                
                this.pagseguroHandler.setPaymentUrl(this.redirectUrl);
                this.pagseguroHandler.initCheckout();
                
            },
            
        }
        
       
        
}
</script>
